import { handleApi } from '../../common';

const PAYMENT_API_ENDPOINT = {
	invest: 'api/invest?version=v2',
};

export const fetch_mf_payment_landing = async ({ params,  Api }) => {
	const url = PAYMENT_API_ENDPOINT.invest;
	const res = await Api.post(url, params);
	return handleApi(res);
};

export const get_mf_polling_status = async ({Api, url}) => {
	const res = await Api.get(url);
	return handleApi(res);
};

export const initiate_mf_payment = async ({Api, url, params}) => {
	// s2s-redirect
	const res = await Api.post(url, params, {});
	return handleApi(res);
};

export const cancel_mf_payment = async ({Api, url}) => {
	const res = await Api.get(url);
	return handleApi(res);
};
